define('modules/editor/views/content_copy_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/content_copy_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/content_copy_popup"),
    triggers: {
      "click .js-copy": "copy",
      "click .js-continue": "continue"
    },

    onRender: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports, {
    show: function(variant) {
      var popup = new module.exports({model: variant}),
          defer = $.Deferred();
      popup.on("copy", _.bind(defer.resolve, defer));
      popup.on("continue", _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));

      return defer.promise();
    }
  });
});

